// @flow
import React, { useEffect, useState } from "react"

import ModalDialog, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';

import { useDispatch, useSelector } from "react-redux";
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3, FEATURE_CUSTOM_REDUX_V4 } from "../../constant";

import reactStringReplace from 'react-string-replace';
import { setDeviceInfoMessage, setJoinRoomWithoutDevice, setZendeskState } from "../../redux/tool-webjam-v2/actions";
import Button from '@atlaskit/button';

// import deviceGuide from "./deviceGuide";
import { deviceCodeChain, INFO_CODE, deviceGuide, systemBootMessage, infoMessages } from "./deviceInfoMessage";
import toast from "react-simple-toasts";
import { addDeviceBox, getBoxRoomApi, getDevicePingStatus, getDeviceRoomApi, getUserBox, getUserLanguage, getUserLocation, saveDeviceConnectSession } from "../../welcome-dashboard/Request.d";
import Spinner from '@atlaskit/spinner';
import { calculateTimeDiff, dispatch, getBaseConfig, getStore, isSocialMobileApp, _startConference, SaveLog, InvitedUserConfirmFlag, _ValidateIPaddress, sleep, getQueryString } from "../../Utils";
import { translateToHTML } from "../../../base/i18n";
import _ from "lodash";
import { Constant, CURRENT_ROOM_NAME } from "../../../webjam/constant";
import { hideApiLoader, setPrejoinDeviceCode, setRoomorIpAddress, showApiLoader } from "../../redux/tool-webjam/actions";
import TimerUI from "./Timer";
import { usePrevious } from "../../welcome-dashboard/Utils";
import { socketEmit, socketOn } from "../../../../../socket";
import { getMySubscription, getPackageList } from "../../welcome-dashboard/paymentRequest";
import { setNotificationMessage, setSubscriptionPackage } from "../../welcome-dashboard/components/payment/payment-reducer/actions";
import { stripeMessage } from "../../welcome-dashboard/messages";
import { NotificationType } from "../../welcome-dashboard/components/payment/Utils";
import Loader from 'react-loader';
import VideoMuteButton from "../../../toolbox/components/VideoMuteButton";
import { Translate } from "../../../webjam/language";

import { E_CODE_MAP } from "../components/deviceInfoMessage";
import refresh from '../../../webjam/components/img/refresh.png';
import { sendData } from "../../../webjam/websocket";
import SpinnerLoader from "./SpinnerLoader";
import { GenericConfirmationModal } from "./GenericConfirmationModal";
import Dialog from "../../../base/ui/components/web/Dialog";
import { setConfirmationModalProps, setIsChinaRegion } from "../../redux/tool-webjam-v3/actions";
import { ct, dynamicMessageLocale } from "../../constant-Utils";
import DevicePreConnection from "./DevicePreConnection";
import Zendesk from "react-zendesk";
import { i18next } from "../../../base/i18n";
import { setVolume } from "../../../filmstrip/actions.web";
import { PushSpinner } from "./PushSpinner";
import UserSubscription from "./UserSubscription";
import { IToolWebjamV4 } from "./../../redux/tool-webjam-v4/reducer"
import { setUserSubscriptionModal } from "./../../redux/tool-webjam-v4/actions"

const ZENDESK_KEY = "a66186d6-1905-41e1-829a-1fff879d1520";

const setting = {
    color: {
        theme: "var(--theme-primary-color) !important"
    },
    position: { horizontal: 'right', vertical: 'top' },
    launcher: {
        chatLabel: {
            '*': 'Chat now'
        },
        mobile: {
            labelVisible: true
        },
    },
    contactForm: {
        fields: [
            { id: "description", prefill: { "*": " " } }
        ]
    },
};

/**
 * 
 * @param {*} props 
 * @returns 
 * mute/unmute video button css
 .prejoin-unmute-video-container {
     position:relative;
 }
.prejoin-unmute-video-container .toolbox-icon,
.prejoin-unmute-video-container .toolbox-icon:hover {
    background:var(--theme-primary-color) !important;
}
.prejoin-unmute-video-container .custom-tooltip {
    left: 59px;
    bottom: calc(100% + 5px);
}
 */

export const ShowDeviceMessageModal = (props) => {
    const {
        deviceInfoMessages,
        allUserDevices,
        isZendeskOpen
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V2])

    const {
        userLoginData,
        usersData
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX])

    const {
        userPaymentSubscription
    } = useSelector(state => state[FEATURE_CUSTOM_PAYMENT])


    const dispatch = useDispatch();
    const [willShow, setWillShow] = useState(false)

    const [tree, setTree] = useState({
        chain: ["light_on"]
    })

    const [initTree, setInitTree] = useState(["light_on"]);

    const [initLink, setInitLink] = useState(true)

    const _closeHelpModal = (current_chain = null) => {
        setInitLink(true);

        setTree({
            chain: ["light_on"]
        });

        dispatch(setDeviceInfoMessage({
            show: false,
            messages: [],

        }, 20));
        setWillShow(false)

        if (current_chain) {
            if (current_chain.indexOf("webcam") != -1) {
                props.handleOnClose(systemBootMessage.DETECT_DEVICE);
            } else if (current_chain.indexOf("microphone") != -1) {
                if (getBaseConfig("prejoinWithoutMic") == true) {
                    props.handleOnClose("without_audio");
                }
            }
        }
    }

    const [formField, setFormField] = useState({
        device_id: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [showHomeConfirm, setShowHomeConfirm] = useState(false);

    const {
        prejoinScreenUserRoute
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V3])

    useEffect(() => {
        return () => {

            setInitLink(true);
            setFormField({
                device_id: ""
            })
        }
    }, [])

    const handleInput = (e) => {

        let val = e.target.value;
        val = val.replace(/[^a-zA-Z0-9]/g, '')

        const {
            name,
            value
        } = e.target;

        if (val) {
            val = val.toUpperCase()
        }

        if (val.length <= 6) {
            setFormField({
                ...formField,
                [name]: val
            })
        }
    }

    const handleDeviceSubmit = async () => {

        if (!userLoginData?.user?.id) {
            dispatch(setConfirmationModalProps({
                isShow: true,
                title: ct("Translate.typography.confirmation"),
                content: ct("Translate.confirmMessages.confirmSocialRedirect"),
                successBtnName: ct("Translate.buttonTitle.okSmall"),
                cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
                onSuccess: () => {
                    if (window.parent != undefined) {
                        window.parent.location.href = Constant.App.socialUrl + "?prejoin_roomname=" + CURRENT_ROOM_NAME
                    } else {
                        window.location.href = Constant.App.socialUrl + "?prejoin_roomname=" + CURRENT_ROOM_NAME
                    }
                },
                onCancel: () => {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                }
            }));
        } else {
            if (!formField.device_id) {
                toast(ct("Translate.messages.enterBoxId"));
                return false
            } else {
                setIsLoading(true);

                let isAdded = await addDeviceBox({
                    device_id: formField.device_id,
                    user_id: userLoginData.user.id
                })

                if (isAdded.status == 1) {

                    let isRegDevice = _.isEqual(tree.chain, deviceCodeChain.REGISTER_DEVICE_INPUT);
                    props.handleOnClose("form_submit", isRegDevice)
                    setIsLoading(false);
                    _closeHelpModal()

                    setFormField({
                        device_id: ""
                    })
                } else {
                    setFormField({
                        device_id: ""
                    })
                    setIsLoading(false)
                }
            }
        }
    }

    const descriptionUI = (description) => {
        let willShow = true;

        if (typeof description == "object") {
            let _description = reactStringReplace(description.title, "click here", (match, i) => {
                return <span className="theme-link-color"
                    onClick={() => {
                        props.handleExternalLink(description.link, "_blank")
                        // window.open(description.link, "_blank")
                    }}
                >{ct("rta-trmc.dashboard.myRoom.clickHere")}</span>
            });
            return (
                <React.Fragment key={"description _ " + Math.random()}>
                    <p className="font16 color-black-tree">
                        {ct(_description)}
                    </p>
                </React.Fragment>
            )
        }

        let box_num = "[BOX_NUMBER]";
        let ctDescription = ct(description);

        if (ctDescription?.indexOf(box_num) != -1) {
            if (allUserDevices.length) {
                ctDescription = reactStringReplace(ctDescription, box_num, (match, i) => {
                    return <b key="show_list">{allUserDevices.join(", ")}</b>
                });

                return (
                    <React.Fragment key={"description _ " + Math.random()}>
                        <p className="font16 color-black-tree">
                            {ctDescription}
                        </p>
                    </React.Fragment>
                )
            } else {
                willShow = false
            }
        }

        if (willShow) {
            let additionalCompo = null;
            let startIcon = description.indexOf(":ICON");
            if (startIcon != -1) {
                let iconType = description.substr(startIcon, description.length);
                description = description.substr(0, startIcon);
                if (iconType.indexOf("unmute-video") != -1) {
                    additionalCompo =
                        <div className="prejoin-unmute-video-container mb-3">
                            <VideoMuteButton />
                        </div>
                }
            }

            return (
                <React.Fragment key={"description _ " + Math.random()}>
                    <p className="font16 color-black-tree" dangerouslySetInnerHTML={{ __html: ct(description) }} >
                    </p>
                    {additionalCompo}
                </React.Fragment>
            )
        } else {
            return null;
        }
    }

    const inputBoxSubmit = (input) => {

        return (
            <React.Fragment key={"input_device"}>
                <input
                    type="text"
                    required
                    placeholder={ct("rta-trmc.premeeting.enterBoxId")}
                    className="rta-box-id-input"
                    name="device_id"
                    maxLength="10"
                    value={formField.device_id || ""}
                    onChange={(e) => {
                        handleInput(e)
                    }}
                />
                <br />
                {
                    !isLoading ?
                        <Button
                            appearance="subtle"
                            className="theme-color color-white mr-2"
                            onClick={handleDeviceSubmit}
                        >{ct("Translate.buttonTitle.submit")}</Button>
                        :
                        <Button
                            appearance="subtle"
                            className="theme-color color-white mr-2"
                        >{ct("Translate.buttonTitle.submit")} <SpinnerLoader size="small" /></Button>
                }

                <br />
                <br />
            </React.Fragment>
        )
    }

    const optionUI = (main, pointer, additional = null) => {
        let setUI = [];

        if (typeof main[pointer] == "object") {
            Object.keys(main[pointer]).map((e, i) => {

                if (["yes", "no", "button"]?.indexOf(e) != -1) {
                    let end_p = [];

                    if (tree.chain[tree.chain.length - 1] == "step_a") {
                        end_p = [...deviceCodeChain.REGISTER_DEVICE, "yes"];
                    }
                    let hasNextChain = false;
                    if (main[pointer][e].hasOwnProperty("waiting")) {
                        end_p = [...end_p, "option", e, "waiting"];
                    } else if (main[pointer][e].hasOwnProperty("need_help")) {
                        end_p = [...end_p, "option", e, "need_help"];
                    } else if (main[pointer][e].hasOwnProperty("nextLink")) {
                        hasNextChain = true;
                    }

                    if (e == "yes" || e == "no") {
                        if (main[pointer][e].hasOwnProperty("button")) {
                            let nextChain = [...tree.chain, ...end_p];
                            if ([...tree.chain, ...end_p].join("-").toString() == deviceCodeChain.STEP_A_NO_YES_LIGHT.join("-").toString()) {
                                if (main[pointer][e].nextLink) {
                                    nextChain = main[pointer][e].nextLink
                                }
                            }
                            setUI.push(
                                <div key={e + "_" + i} className="w-100 d-block">
                                    <span
                                        className="theme-font-c cursor-pointer"
                                        // data-nest={JSON.stringify([...tree.chain, ...end_p])}
                                        // data-chain={JSON.stringify(tree.chain)}
                                        onClick={() => {
                                            setTree({
                                                chain: [...nextChain]
                                            })
                                        }}
                                    >{ct(main[pointer][e]["button"]["title"])}</span>
                                </div>
                            )
                            if (main[pointer][e]["button"].hasOwnProperty("title_b")) {
                                setUI.push(
                                    <div key={e + "_vd" + i} className="w-100 d-block">
                                        <span
                                            style={{
                                                color: "#333"
                                            }}
                                            className="mt-1 mb-1"
                                        >{ct(main[pointer][e]["button"]["title_b"])}</span>
                                    </div>
                                )
                            }

                        } else if (e == "yes") {
                            setUI.push(descriptionUI(main[pointer][e]["description"]))

                            if (main[pointer][e].hasOwnProperty("option")) {
                                let getData = optionUI(main[pointer][e], "option", true)
                                getData.map(d => setUI.push(d))
                            }
                        } else if (e == "no") {
                            if (main[pointer][e].hasOwnProperty("description")) {
                                setUI.push(descriptionUI(main[pointer][e]["description"]))
                            }

                        }
                    } else if (e == "button") {
                        Object.keys(main[pointer][e]).map((d, j) => {

                            let nextChain = [...tree.chain, "option", d];

                            if (nextChain[nextChain.length - 1] == "step_a") {
                                nextChain = [...nextChain, ...deviceCodeChain.REGISTER_DEVICE, "yes"]
                            }

                            setUI.push(
                                <div key={d + "_" + j} className="w-100 d-block">
                                    <span
                                        className="theme-font-c cursor-pointer"
                                        data-set={JSON.stringify(nextChain)}
                                        onClick={() => {
                                            setTree({
                                                chain: nextChain
                                            })
                                            // handleNextTree([...tree.chain, "option", d])
                                        }}
                                    >{ct(main[pointer][e][d]["title"])}</span>
                                </div>
                            )
                        })

                    }
                    // }
                }
            })
        }
        return setUI;
    }

    const TriggerZenDesk = (error_code, sendMessage = false) => {
        try {
            // if no error_code is provided OR no E_CODE_MAP found then just open the zenDesk and return
            _closeHelpModal();
            if (!E_CODE_MAP[error_code] || !error_code) {
                if (!sendMessage) {
                    // return zE('messenger', 'open');
                    return zE('webWidget', 'open');
                }
            }

            // if error_code found then create prefill message string and open the zenDesk with user details
            let additionalMessage = "";
            if (E_CODE_MAP[error_code]) {
                additionalMessage = `\nError Message: ${E_CODE_MAP[error_code]}`
            }

            zE('webWidget', 'open');

            const zenDesk_message = `Name: ${userLoginData?.user?.username} \nEmail: ${userLoginData?.user?.email} \n\nError Code: ${error_code} ${additionalMessage}`

            zE('webWidget', 'identify', {
                name: userLoginData?.user?.username + " " + error_code,
                email: userLoginData?.user?.email
            });
        } catch (e) {
            console.log("Zendesk error =>", e)
        }

    }



    const checklistUI = (checklist) => {
        let return_data = [];
        let hasLink = 0;
        checklist.map((e, k) => {
            if (typeof e == "string") {
                return_data.push(<li id={`checklist-${k}`} key={k}>{ct(e)}</li>)
            } else {
                if (e.title) {
                    hasLink++;
                    if (e.link != undefined) {
                        if (e.link == systemBootMessage.REINIT_SYSTEM) {
                            return_data.push(<li id={`checklist-${k}`} key={k}>
                                {reactStringReplace(e.title.toLowerCase(), "click here", () => {
                                    return <span className="theme-font-c cursor-pointer" key={e.title} onClick={() => {
                                        props.handleOnClose(e.link);
                                        _closeHelpModal()
                                    }}>{ct("rta-trmc.dashboard.myRoom.clickHere")}</span>
                                })}
                            </li>)
                        } else if (e.link == systemBootMessage.DETECT_DEVICE) {
                            return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 1"
                                onClick={() => {
                                    props.handleOnClose(e.link);
                                    _closeHelpModal()
                                }}
                            >{ct(e.title)}</li>)
                        } else if (e.link == systemBootMessage.ALL_SET) {
                            let willProcess = true;

                            if (tree.chain.indexOf("microphone") != -1) {
                                if ((tree.chain.indexOf("not_allowed") != -1 || tree.chain.indexOf("not_available") != -1)) {
                                    if (getBaseConfig("prejoinWithoutMic") == false) {
                                        willProcess = false;
                                    }
                                }
                            }

                            if (willProcess) {
                                if (usersData == null) {

                                }
                            }
                            // if(usersData)
                            if (willProcess) {
                                return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 2"
                                    onClick={() => {
                                        // setTree({
                                        //     chain: deviceCodeChain.ALL_SET
                                        // })
                                        if (getBaseConfig("prejoinWithoutMic") == true) {
                                            props.handleOnClose("without_audio");
                                            // _closeHelpModal()
                                        }
                                        // props.handleOnClose(e.link);
                                        // _closeHelpModal()
                                    }}
                                >{ct(e.title)}</li>)
                            }
                        } else if (e.link == systemBootMessage.JOIN_MEETING) {
                            return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 3"
                                onClick={() => {
                                    // setTree({
                                    //     chain: deviceCodeChain.JOIN_MEETING
                                    // })
                                    // props.handleOnClose("join_without")
                                    _closeHelpModal()
                                    // dispatch(setJoinRoomWithoutDevice(true))
                                    // props.handleOnClose(e.link);
                                    // _closeHelpModal()
                                }}
                            >{ct(e.title)}</li>)
                        } else if (e.link == systemBootMessage.SUBSCRIPTION_SHOW || e.link == systemBootMessage.SUBSCRIPTION_SHOW_BASIC || e.link == systemBootMessage.AUDIO) {
                            if (e.link == systemBootMessage.SUBSCRIPTION_SHOW || e.link == systemBootMessage.SUBSCRIPTION_SHOW_BASIC) {
                                let askLogin = false;
                                if (getBaseConfig("prejoinLoginRequired") == true) {
                                    if (!userLoginData?.user?.id) {
                                        askLogin = true;
                                    } else if (userLoginData?.user?.id && userLoginData?.user?.is_invited == true && !userLoginData?.user?.email) {
                                        askLogin = true;
                                    }
                                }
                                var addinl = "";
                                if (usersData != null) {
                                    if (e.hasOwnProperty("checkDeviceConnected")) {
                                        addinl = "userConnectedWantBasic"
                                    }
                                }

                                if (!askLogin) {
                                    return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 4" data-set={`${k} + 1`} data-che={JSON.stringify(e)}
                                        onClick={() => {
                                            _closeHelpModal()
                                            props.handleOnClose(e.link, addinl);
                                        }}
                                    >{ct(e.title)}</li>)
                                }
                            } else {
                                return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 5" data-set={`${k} + 2`} data-chew={JSON.stringify(e)}
                                    onClick={() => {
                                        _closeHelpModal()
                                        props.handleOnClose(e.link);
                                    }}
                                >{ct(e.title)}</li>)
                            }
                        } else if (e.link == systemBootMessage.DEVICE_RECHECK) {
                            if (usersData == null) {
                                if (prejoinScreenUserRoute == InvitedUserConfirmFlag.WITHOUT_DEVICE) {

                                } else {
                                    return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 6"
                                        onClick={() => {
                                            _closeHelpModal()
                                            props.handleOnClose(e.link);
                                        }}
                                    >{ct(e.title)}</li>)
                                }
                            }
                        }

                        // else if (e.link == systemBootMessage.SUBSCRIPTION_SHOW_BASIC) {
                        //     return_data.push(<li key={k} className="theme-font-c cursor-pointer checklist-item-theme"
                        //         onClick={() => {
                        //             _closeHelpModal()
                        //             props.handleOnClose(e.link,"checklist view show subscription");
                        //         }}
                        //     >{e.title}</li>)
                        // }  else if(e.link == systemBootMessage.AUDIO) {
                        //     return_data.push(<li key={k} className="theme-font-c cursor-pointer checklist-item-theme"
                        //     onClick={() => {
                        //         _closeHelpModal()
                        //         props.handleOnClose(e.link,"checklist view show subscription");
                        //     }}
                        // >{e.title}</li>)

                        //     // _closeHelpModal()
                        //     // props.handleOnClose(e.link,"checklist view show audio");
                        // } 

                        else {
                            return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme  7 "
                                onClick={() =>
                                    props.handleExternalLink(e.link, "_blank")
                                    // window.open(e.link, "_blank")

                                }
                            >{ct(e.title)}</li>)
                        }
                    } else if (e.chainVal != undefined) {
                        let willShow = true;
                        if (e.hasOwnProperty("check_basic_subscription")) {
                            let hasSubscription = userHasSubscription(true, "prejoin")
                            if (hasSubscription) {
                                willShow = false;
                                if (userPaymentSubscription.is_premium) {
                                    willShow = false;
                                }
                            }
                        }
                        if (willShow) {
                            return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme font16"
                                onClick={() => {
                                    setTree({
                                        chain: [...e.chainVal]
                                    })
                                }}
                            >{ct(e.title)}</li>)
                        } else {
                            if (e.hasOwnProperty("nextLink")) {
                                if (userLoginData?.user?.is_invited == true) {
                                    return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme font16"
                                        onClick={() => {
                                            props.handleOnClose(systemBootMessage.AUDIO, "user have device but want to join without, user is guest and invited");
                                            _closeHelpModal()
                                        }}
                                    >{ct(e.title)}</li>)
                                } else {
                                    return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme font16"
                                        onClick={() => {
                                            props.handleOnClose(e.nextLink, "user have device but want to join without");
                                            _closeHelpModal()
                                        }}
                                    >{ct(e.title)}</li>)
                                }
                            }
                        }
                    } else {
                        if (e.will_join != undefined) {
                            return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 8"
                                onClick={() => {
                                    props.handleOnClose(systemBootMessage.SUBSCRIPTION_SHOW_BASIC, "check list but will join defined");
                                    _closeHelpModal()
                                }}
                            >{ct(e.title)}</li>)
                        } else if (e.contact != undefined) {
                            return_data.push(<li id={`checklist-${k}`} key={k} className="theme-font-c cursor-pointer checklist-item-theme 9"
                                onClick={() => {
                                    TriggerZenDesk(e?.contact?.info_code || deviceInfoMessages?.info_code, e?.info_code ? true : false)
                                }}
                            >{ct(e?.title)}</li>)

                            if (e.contact?.info_code != undefined) {
                                return_data.push(<div className="text-right color-black-tree pull-right"><p>{ct("rta-trmc.premeeting.code")}: {e.contact?.info_code}</p></div>)
                            }
                        } else {
                            return_data.push(<li id={`checklist-${k}`} key={k} className="">{ct(e.title)}</li>)
                        }
                    }
                }
            }
        })

        return (<React.Fragment key={"checklist"}>
            {
                hasLink > 0
                    ? <ul className="no-list-style font16 u-device-checklist pl-0">{return_data}</ul>
                    : <ul>{return_data}</ul>
            }

        </React.Fragment>)
    }

    const showWaitingTimer = (chain) => {
        let _chainW = [...chain]
        let _showList = deviceGuide;
        try {
            while (_chainW.length) {
                let _first = _chainW.shift();
                _showList = _showList[_first];
            }
        } catch (e) {
            console.log("showWaitingTimer error =>", e)
        }

        let _main = _showList;

        if (_main.hasOwnProperty("timer")) {
            return <>
                <br />{ct("rta-trmc.dialogs.willCompleteIn")}
                <TimerUI
                    seconds={_main.timer}
                    hideTimer={(type) => {
                        handleTimeout(type, _main)
                    }}
                />
            </>
        }
        return null;
    }

    const handleTimeout = (type, _main) => {
        // props.handleOnClose(systemBootMessage.WAITING_EXPIRE)
        if (_main.hasOwnProperty("next_wait")) {
            setTree({
                chain: [...deviceCodeChain.REGISTER_DEVICE_INPUT_SHOW]
            })
        } else {
            dispatch(setPrejoinDeviceCode(INFO_CODE.UNKNOWN_ERROR))
            props.handleOnClose(systemBootMessage.WAITING_EXPIRE)

            setTree({
                chain: [...deviceCodeChain.UNKNOWN_ERROR]
            })
        }
    }

    const messageView = (json) => {
        // To reset zendesk data when it is closed by user
        try {
            zE('webWidget:on', 'close', function () {
                zE('webWidget', "updateSettings", {
                    contactForm: {
                        fields: [
                            { id: "description", prefill: { "*": "" } },
                            { id: "email", prefill: { "*": "" } },
                            { id: "name", prefill: { "*": "" } },
                        ]
                    }
                });
            });
        } catch (e) {

        }

        let chain = tree.chain;
        let chainW = [...chain]
        let showList = json;
        try {
            while (chainW.length) {
                let first = chainW.shift();
                showList = showList[first];
            }
        } catch (e) {
            console.log("messageView error =>", e)
        }

        let main = showList;
        if (main != undefined) {
            let keys = Object.keys(main);
            let setUI = [];

            for (let i = 0; i < keys.length; i++) {

                let pointer = keys[i]
                let value = main[keys[i]];
                switch (pointer) {
                    case "title":
                        setUI.push(
                            <p
                                key="title"
                                className="font18 color-black-tree"
                            >
                                {ct(value)}
                                {
                                    showWaitingTimer(tree.chain)
                                }
                            </p>
                        )
                        break;
                    case "title_b":
                        setUI.push(
                            <p
                                key="title_b"
                                className="font18 color-black-tree"
                                dangerouslySetInnerHTML={{ __html: ct(value) }}
                            >
                            </p>
                        )
                        break;

                    case "yes":
                        setUI.push(
                            <React.Fragment key="yes">
                                <Button
                                    appearance="subtle"
                                    className="theme-color color-white mr-2 urs-sl-ys mb-3"
                                    onClick={() => {
                                        setTree({
                                            chain: [...tree.chain, pointer]
                                        })
                                    }}
                                >{ct("Translate.buttonTitle.yesSmall")}</Button>
                            </React.Fragment>)
                        break;

                    case "no":
                        setUI.push(
                            <React.Fragment key="no">
                                <Button
                                    appearance="subtle"
                                    className="cancel-button mb-3"
                                    onClick={() => {
                                        setTree({
                                            chain: [...tree.chain, pointer]
                                        })
                                    }}
                                >{ct("Translate.buttonTitle.noSmall")}</Button>
                            </React.Fragment>)
                        break;
                    case "checklist":
                        setUI.push(checklistUI(main[pointer]))
                        break;
                    case "description":
                        setUI.push(descriptionUI(main[pointer]))
                        break;
                    case "description_b":
                        setUI.push(descriptionUI(main[pointer]))
                        break;
                    case "input_box":
                        setUI.push(inputBoxSubmit(main[pointer]))
                        break;
                    case "contact":
                        // if (main[pointer].hasOwnProperty("description")) {
                        //     setUI.push(descriptionUI(main[pointer].description))
                        // }
                        setUI.push(
                            <React.Fragment key={"contact"}>
                                <span onClick={() => {
                                    props.handleExternalLink(main[pointer].link, "_blank")
                                    // window.open(main[pointer].link, "_blank")
                                }}
                                    className="theme-font-c cursor-pointer w-100 d-block"
                                >
                                    {ct("rta-trmc.premeeting.webcamNotAvailable.troubleshootTitle")}
                                    {/* {tree.chain.join(" -> ")} */}
                                </span>

                                <span onClick={() => {
                                    TriggerZenDesk(main[pointer].info_code || deviceInfoMessages?.info_code, main[pointer]?.info_code ? true : false)
                                }}
                                    className="theme-font-c cursor-pointer w-100 d-block"
                                >
                                    {ct("rta-trmc.premeeting.webcamNotAvailable.contactSupportTitle")}
                                </span>
                                {
                                    main[pointer].firewall_link != undefined
                                        ? <span onClick={() => {
                                            props.handleExternalLink(main[pointer].firewall_link, "_blank")
                                            // window.open(main[pointer].firewall_link, "_blank")
                                        }}
                                            className="theme-font-c cursor-pointer w-100 d-block"
                                        >{ct("rta-trmc.premeeting.firewallLink")}</span> : null
                                }
                                {
                                    main[pointer].mesh_link != undefined
                                        ? <span onClick={() => {
                                            props.handleExternalLink(main[pointer].mesh_link, "_blank")
                                            // window.open(main[pointer].mesh_link, "_blank")
                                        }}
                                            className="theme-font-c cursor-pointer w-100 d-block"
                                        >{ct("rta-trmc.premeeting.meshLink")}</span> : null
                                }
                                {
                                    main[pointer].info_code != undefined
                                        ?
                                        <div
                                            className="text-right color-black-tree pull-right"
                                        ><p>{ct("rta-trmc.premeeting.code")}: {main[pointer].info_code}</p>
                                        </div>
                                        : null
                                }
                            </React.Fragment>)
                        break;
                    case "option":
                    case "port_issue":
                        let UI = optionUI(main, pointer)
                        UI.map(e => setUI.push(e))
                        break;
                    case "bottom_title":
                        setUI.push(
                            <React.Fragment key={"bottom_title"}>
                                <div
                                    className="color-black-tree w-100 d-block"
                                    dangerouslySetInnerHTML={{ __html: ct(value) }}
                                >
                                </div>
                            </React.Fragment>)
                        break;
                    case "askLogin":
                        let askLogin = false;
                        if (getBaseConfig("prejoinLoginRequired") == true) {
                            if (!userLoginData?.user?.id) {
                                askLogin = true;
                            } else if (userLoginData?.user?.id && userLoginData?.user?.is_invited == true && !userLoginData?.user?.email) {
                                askLogin = true;
                            }
                        }

                        if (askLogin) {
                            setUI.push(
                                <React.Fragment key={"login-link"}>
                                    <div
                                        className="theme-font-c cursor-pointer checklist-item-theme font16"
                                        onClick={() => {
                                            dispatch(setConfirmationModalProps({
                                                isShow: true,
                                                title: ct("Translate.typography.confirmation"),
                                                content: ct("Translate.confirmMessages.socialRedirect"),
                                                onSuccess: () => {
                                                    if (window.parent != undefined) {
                                                        window.parent.location.href = Constant.App.socialUrl + "?prejoin_roomname=" + CURRENT_ROOM_NAME
                                                    } else {
                                                        window.location.href = Constant.App.socialUrl + "?prejoin_roomname=" + CURRENT_ROOM_NAME
                                                    }
                                                },
                                                onCancel: () => {
                                                    dispatch(setConfirmationModalProps({ isShow: false }));
                                                }
                                            }));
                                        }}
                                    >{ct(("rta-trmc.premeeting.signInSignUp"))}
                                    </div>
                                </React.Fragment>)
                        }
                        break;
                    case "info_code":
                        setUI.push(infoCodeUI(value))
                        break;
                }
            }

            return setUI;
            // setGraphicUI(setUI)
        }
        return null;
    }

    const infoCodeUI = (infoCode, noWrapper = false) => {

        if (noWrapper) {
            return <div
                className="text-right color-black-tree pull-right"
            ><p>{ct("rta-trmc.premeeting.code")}: {infoCode}</p>
            </div>
        }
        return (<React.Fragment key={"info-code"}>
            <div
                className="text-right color-black-tree pull-right"
            // onClick={() => {
            //     TriggerZenDesk(infoCode)
            // }}
            ><p>{ct("rta-trmc.premeeting.code")}: {infoCode}</p>
            </div>
        </React.Fragment>)
    }

    const initMessageView = () => {

        let data = deviceGuide.primary_link;

        let _setUI = []
        for (let i = 0; i < data.length; i++) {
            if (data[i].button != undefined) {
                if (data[i].button.hasOwnProperty("description")) {
                    _setUI.push(<div key={"list_" + i} className="w-100 d-block mb-2 ">
                        <span
                            style={{ color: "#333" }}
                            className={"mb-2 " + (data[i].button?.class || "")}
                        >{ct(data[i].button.description)}</span>
                    </div>)
                } else {
                    _setUI.push(<div key={"list_" + i} className="w-100 d-block mb-2 ">
                        <span
                            className="theme-font-c cursor-pointer font16"
                            onClick={() => {
                                if (data[i].button.hasOwnProperty("link")) {
                                    // window.open(data[i].button.link, "_blank")
                                    props.handleExternalLink(data[i].button.link, "_blank")
                                } else if (data[i].button.hasOwnProperty("will_join")) {
                                    props.handleOnClose("join_without", "init message")
                                    _closeHelpModal()
                                    // dispatch(setJoinRoomWithoutDevice(true))
                                } else if (data[i].button.hasOwnProperty("next_move")) {
                                    props.handleOnClose(data[i].button.next_move, "I have next move ")
                                    _closeHelpModal()
                                } else {
                                    handleUserProgress()
                                }
                            }}
                        >{ct(data[i].button.title)}</span>
                    </div>)
                }
            } else if (data[i].info_code != undefined) {
                _setUI.push(infoCodeUI(data[i].info_code))
            }
        }
        return _setUI;
    }

    const handleUserProgress = () => {

        setInitLink(false)

        setTree({
            chain: ["light_on"]
        })

        handleCal()
    }

    const getInfoCode = () => {
        let infoCode = deviceInfoMessages.info_code;
        let firstCode = infoCode;
        if (firstCode) {
            try {
                if (infoCode?.indexOf(", ") != -1) {
                    let splt = infoCode?.split(", ");
                    if (splt.length) {
                        firstCode = infoCode?.split(", ")[0]
                    }
                }
            } catch (e) {
                console.log("getInfoCode error =>", e)
            }
        }
        return firstCode;
    }

    const handleCal = () => {
        let firstCode = getInfoCode()

        if (firstCode) {
            let treeData = [];
            switch (firstCode) {
                case INFO_CODE.NO_DEVICE_DETECT:
                    treeData = deviceCodeChain.DEFAULT
                    break;

                case INFO_CODE.NO_INTER:
                    treeData = [...deviceCodeChain.INTERFACE, "no"]
                    break;

                case INFO_CODE.SYMMETRIC_NAT:
                    treeData = [...deviceCodeChain.NET_PORT_ISSUE]
                    break;

                case INFO_CODE.BUFFER_ISSUE:
                    treeData = [...deviceCodeChain.BUFFER_ISSUE]
                    break;
                case INFO_CODE.PRIVATE_FIREWALL_ISSUE:
                    treeData = [...deviceCodeChain.PRIVATE_FIREWALL_ISSUE]
                    break;

                case INFO_CODE.WEBCAM_NOT_AVAILABLE:
                    treeData = [...deviceCodeChain.RTA_WEBCAM_NOT_WORKING, "not_available"]
                    break;
                case INFO_CODE.WEBCAM_NOT_ALLOWED:
                    treeData = [...deviceCodeChain.RTA_WEBCAM_NOT_WORKING, "not_allowed"]
                    break;

                case INFO_CODE.WEBCAM_MUTED:
                    treeData = [...deviceCodeChain.RTA_WEBCAM_NOT_WORKING, "muted"]
                    break;

                case INFO_CODE.MICROPHONE_NOT_AVAILABLE:
                    treeData = [...deviceCodeChain.RTA_MICROPHONE_NOT_WORKING, "not_available"]
                    break;
                case INFO_CODE.MICROPHONE_NOT_ALLOWED:
                    treeData = [...deviceCodeChain.RTA_MICROPHONE_NOT_WORKING, "not_allowed"]
                    break;
                case INFO_CODE.MICROPHONE_MUTED:
                    treeData = [...deviceCodeChain.RTA_MICROPHONE_NOT_WORKING, "muted"]
                    break;

                case INFO_CODE.UNKNOWN_ERROR:
                    treeData = [...deviceCodeChain.UNKNOWN_ERROR]
                    break;
                case INFO_CODE.UNKNOWN_ERROR_CONNECT:
                    treeData = [...deviceCodeChain.UNKNOWN_ERROR_CONNECT]
                    break;

                case INFO_CODE.ALL_SET:
                    treeData = [...deviceCodeChain.ALL_SET]
                    break;
                case INFO_CODE.WAITING_DEVICE:
                    treeData = [...deviceCodeChain.WAITING_DEVICE]
                    break;
                case INFO_CODE.SUBSCRIPTION:
                    treeData = [...deviceCodeChain.SUBSCRIPTION]
                    break;
                case INFO_CODE.BASIC_SUBSCRIPTION:
                    treeData = [...deviceCodeChain.BASIC_SUBSCRIPTION]
                    break;
            }
            if (treeData.length) {
                setInitLink(false)
                setWillShow(true)
                setTree({ chain: treeData })
                setInitTree(treeData)
            }
        }
    }
    let prevShow = usePrevious(deviceInfoMessages?.show);

    useEffect(() => {
        if (deviceInfoMessages?.show) {
            let firstCode = getInfoCode()

            let showInit = false;
            if (deviceInfoMessages.hasOwnProperty("no_device")) {
                if (deviceInfoMessages.no_device) {
                    showInit = true;
                    setInitLink(true)
                    setWillShow(true)
                }
            }

            if (!showInit) {
                setInitLink(false);
                handleCal();
            }
        }

        if (deviceInfoMessages.show) {
            if (window.innerWidth < 768) {
                if (document.getElementById("launcher")) {
                    let { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
                    if (getBaseConfig("showPreJoiningInConference") && showDevicePreConnection) {
                        document.getElementById("launcher").style.display = '';
                    } else {
                        document.getElementById("launcher").style.display = 'none';
                    }
                }
            }
        } else {
            if (window.innerWidth < 768) {
                if (document.getElementById("launcher")) {
                    let { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
                    if (getBaseConfig("showPreJoiningInConference") && showDevicePreConnection) {
                        document.getElementById("launcher").style.display = '';
                    } else {
                        document.getElementById("launcher").style.display = 'block';
                    }
                }
            }
        }

    }, [deviceInfoMessages?.show]);

    let prevInfo = usePrevious(deviceInfoMessages)
    useEffect(() => {
        let showInit = false;
        if (deviceInfoMessages.hasOwnProperty("info_code")) {
            if (deviceInfoMessages.info_code == INFO_CODE.NO_DEVICE_DETECT) {
                showInit = true;
                setInitLink(true)
            }
        }

        if (!showInit) {
            if (prevInfo) {
                if (prevInfo.hasOwnProperty("info_code") && deviceInfoMessages.hasOwnProperty("info_code")) {
                    if (prevInfo.info_code != deviceInfoMessages.info_code) {
                        handleCal()
                    }
                }
            }
        }
    }, [deviceInfoMessages])

    const handleBack = (backChain, hideInit = false) => {
        if (_.isEqual(backChain, deviceCodeChain.DEFAULT)) {
            if (hideInit) {
                setInitLink(true)
            } else {
                setTree({
                    chain: [...backChain]
                })
            }
        } else {
            setTree({
                chain: [...backChain]
            })
        }
    }


    const renderBackUI = () => {
        let chain = tree.chain;
        let curChain = chain.join("-").toString()
        if (initLink) {
            return null;
        } else if (curChain == deviceCodeChain.NET_PORT_ISSUE.join("-").toString()) {
            return null;
        }

        let backChain = [];
        let init = false;

        if (_.isEqual(chain, deviceCodeChain.DEFAULT)) {
            backChain = deviceCodeChain.DEFAULT;
            init = true
        } else if (_.isEqual(chain, [...deviceCodeChain.DEFAULT, "yes"]) || _.isEqual(chain, [...deviceCodeChain.DEFAULT, "no"])) {
            backChain = [...deviceCodeChain.DEFAULT];
        } else if (_.isEqual(chain, [...deviceCodeChain.STEP_A_NO_YES_LIGHT]) || _.isEqual(chain, [...deviceCodeChain.STEP_A_NO_NO_LIGHT])) {
            backChain = [...deviceCodeChain.DEFAULT, "no"];
        } else if (curChain == deviceCodeChain.REGISTER_DEVICE_WAITING.join("-").toString()
            || curChain == deviceCodeChain.PRIVATE_FIREWALL_ISSUE.join("-").toString()
            || curChain == deviceCodeChain.STEP_C_YES.join("-").toString()
        ) {
            backChain = [...deviceCodeChain.DEFAULT, "yes"];
        } else if (curChain == deviceCodeChain.STEP_A_YES_C_A.join("-").toString()
            || curChain == deviceCodeChain.STEP_A_YES_C_B.join("-").toString()) {
            backChain = [...deviceCodeChain.STEP_C_YES];
        } else if (curChain == deviceCodeChain.STEP_A_YES_B_A.join("-").toString()
            || curChain == deviceCodeChain.STEP_A_YES_B_B.join("-").toString()
        ) {
            backChain = [...deviceCodeChain.PRIVATE_FIREWALL_ISSUE];
        } else if (curChain == deviceCodeChain.NET_PORT_ISSUE.concat(["option", "yes", "waiting"]).join("-").toString()
            || curChain == deviceCodeChain.NET_PORT_ISSUE.concat(["option", "no", "need_help"]).join("-").toString()
        ) {
            backChain = [...deviceCodeChain.NET_PORT_ISSUE];

        } else if (curChain == deviceCodeChain.INTERFACE.concat(["no", "option", "yes", "waiting"]).join("-").toString()
            || curChain == deviceCodeChain.INTERFACE.concat(["no", "option", "no", "need_help"]).join("-").toString()
        ) {
            backChain = [...deviceCodeChain.INTERFACE, "no"];
        } else if (curChain == deviceCodeChain.BASIC_SUBSCRIPTION.join("-").toString()
        ) {
            if (usersData != null) {
                backChain = [...deviceCodeChain.SUBSCRIPTION];
            }
        } else if (curChain == deviceCodeChain.REGISTER_DEVICE_INPUT_SHOW.join("-").toString()) {
            backChain = [...deviceCodeChain.REGISTER_DEVICE_WAITING];
        }
        // if (!backChain.length) return null;
        // if length is zero then show back button otherwise hide back button
        return { show: backChain.length, backChain, init };
        // return (
        //     <Button appearance="subtle" className="cancel-button pull-right" onClick={() => handleBack(backChain, init)} >Back</Button>
        // )
    }

    const renderSelection = () => {

        let chain = tree.chain;
        let curChain = chain.join("-").toString();

        let willSelect = false;
        if (_.isEqual(chain, deviceCodeChain.DEFAULT)
            || _.isEqual(chain, [...deviceCodeChain.DEFAULT, "yes"])
            || _.isEqual(chain, [...deviceCodeChain.DEFAULT, "no"])
            || _.isEqual(chain, [...deviceCodeChain.PRIVATE_FIREWALL_ISSUE])
            || _.isEqual(chain, [...deviceCodeChain.STEP_C_YES])
            || _.isEqual(chain, [...deviceCodeChain.STEP_A_YES_B_B])
            || _.isEqual(chain, [...deviceCodeChain.STEP_A_YES_C_B])
            || _.isEqual(chain, [...deviceCodeChain.STEP_A_NO_NO_LIGHT])
            || _.isEqual(chain, [...deviceCodeChain.NET_PORT_ISSUE])
            || _.isEqual(chain, [...deviceCodeChain.NET_PORT_ISSUE, "option", "no", "need_help"])
            || _.isEqual(chain, [...deviceCodeChain.INTERFACE, "no"])
            || _.isEqual(chain, [...deviceCodeChain.REGISTER_DEVICE_INPUT_SHOW])
            || _.isEqual(chain, [...deviceCodeChain.INTERFACE, "no", "option", "no", "need_help"])
            || _.isEqual(chain, ["subscription"])
            || _.isEqual(chain, ["basic_subscription"])
            || _.isEqual(chain, ["webcam", "not_allowed"])
            || _.isEqual(chain, ["webcam", "not_available"])
            || _.isEqual(chain, ["microphone", "not_allowed"])
            || _.isEqual(chain, ["microphone", "not_available"])
            || _.isEqual(chain, [...deviceCodeChain.UNKNOWN_ERROR])
            || _.isEqual(chain, [...deviceCodeChain.UNKNOWN_ERROR_CONNECT])
        ) {
            willSelect = true;
        }

        let willCheck = false;
        if (_.isEqual(chain, deviceCodeChain.STEP_A_NO_YES_LIGHT)
            || _.isEqual(chain, [...deviceCodeChain.STEP_A_YES_B_A])
            || _.isEqual(chain, [...deviceCodeChain.STEP_A_YES_C_A])
            || _.isEqual(chain, [...deviceCodeChain.REGISTER_DEVICE_WAITING])
            || _.isEqual(chain, [...deviceCodeChain.NET_PORT_ISSUE, "option", "yes", "waiting"])
            || _.isEqual(chain, [...deviceCodeChain.INTERFACE, "no", "option", "yes", "waiting"])
        ) {
            willCheck = true;
        }

        if (willSelect) {
            return {
                type: "list",
                message: ct("rta-trmc.premeeting.selectAnyOption")
            }
            return ct("rta-trmc.premeeting.selectAnyOption");
        }

        if (willCheck) {
            return {
                type: "checking",
                message: ct("rta-trmc.premeeting.systemChecking")
            }
            return ct("rta-trmc.premeeting.systemChecking");
        }

        return {
            type: "default",
            message: ct("rta-trmc.premeeting.oops")
        }
        return ct("rta-trmc.premeeting.oops");
    }


    const handleGoHome = (willGoBack = false) => {
        try {
            if (willGoBack) {
                if (isSocialMobileApp()) {
                    window.location.href = getBaseConfig("appReferrerUrl");
                } else {
                    if (window.parent) {
                        window.parent.location.href = getBaseConfig("socialReferrerUrl")
                    } else {
                        window.location.href = getBaseConfig("socialReferrerUrl")
                    }
                }
            } else {
                setShowHomeConfirm(true)
            }
        } catch (e) {
            console.log("handleGoHome error =>", e)
        }
    }

    const getCancelHomeBtn = (getCancel = true, getHome = false) => {
        if (getCancel) {
            if (tree.chain.join("_") == "unknown_error"
                || tree.chain.join("_") == "unknown_error_connect"
                || tree.chain.join("_") == "all_set"
                || tree.chain.indexOf("webcam") != -1
                || tree.chain.indexOf("microphone") != -1) {
                // if (text) {
                //     return "Close";
                // }

                // return _closeHelpModal(tree.chain)

                // return <Button
                //     id="close-join-meeting-btn"
                //     appearance="subtle"
                //     className="cancel-button pull-right"
                //     onClick={() => _closeHelpModal(tree.chain)} >Close</Button>

                return {
                    hide: false,
                    text: ct("Translate.buttonTitle.closeSmall"),
                    handle: () => _closeHelpModal(tree.chain)
                }
            }

            return {
                hide: true,
                text: ct("Translate.buttonTitle.closeSmall"),
                handle: () => { }
            }
        }

        if (getHome) {
            let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
            if (getBaseConfig("prejoinRedirectToSocialButton") == true && (getBaseConfig("showPreJoiningInConference") == false || (getBaseConfig("showPreJoiningInConference") == true && !conferenceJoined))) {
                if (renderSelection().type == "list") {
                    return <div
                        className={"w-100 d-block mb-2 " + (
                            tree.chain.join("_") == "unknown_error"
                                || tree.chain.join("_") == "basic_subscription"
                                || tree.chain.join("_") == "subscription"

                                ? "mtn-6" : (
                                    _.isEqual(tree.chain, [...deviceCodeChain.RTA_WEBCAM_NOT_WORKING, "not_available"])
                                        || _.isEqual(tree.chain, [...deviceCodeChain.RTA_MICROPHONE_NOT_WORKING, "not_available"])
                                        ? "mtn-5"
                                        : ""
                                ))}
                        onClick={() => handleGoHome(false)}
                    ><span
                        className={"theme-font-c cursor-pointer " + (
                            initLink
                                || tree.chain.join("_") == "unknown_error"
                                || tree.chain.join("_") == "basic_subscription"
                                || tree.chain.join("_") == "subscription"
                                || _.isEqual(tree.chain, [...deviceCodeChain.RTA_WEBCAM_NOT_WORKING, "not_available"])
                                || _.isEqual(tree.chain, [...deviceCodeChain.RTA_MICROPHONE_NOT_WORKING, "not_available"])
                                ? "font16" : "")}>{ct("rta-trmc.premeeting.goHome")}</span>
                    </div>
                }
            }
        }
        return null
    }

    let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
    if (deviceInfoMessages?.show && willShow && !isZendeskOpen && getBaseConfig("showPreJoiningInConference") == true && conferenceJoined && deviceInfoMessages?.info_code == INFO_CODE.ALL_SET) {
        return null;
    } else if (deviceInfoMessages?.show && willShow && !isZendeskOpen) {
        return (
            <>
                {showHomeConfirm &&
                    <GenericConfirmationModal
                        title={ct("rta-trmc.premeeting.home")}
                        successBtnName={ct("Translate.buttonTitle.yesSmall")}
                        cancelBtnName={ct("Translate.buttonTitle.cancelSmall")}
                        content={ct("Translate.confirmMessages.welcomePageHome")}
                        onSuccess={() => handleGoHome(true)}
                        onCancel={() => setShowHomeConfirm(false)} />
                }

                <ModalTransition>
                    <div className="webjam-popup custom-webjam-popup">
                        <Dialog
                            titleKey={
                                tree?.chain[0] == "all_set"
                                    || deviceInfoMessages.info_code == INFO_CODE.ALL_SET
                                    ? ct("rta-trmc.premeeting.allSetText") : renderSelection().message}
                            hideCloseButton={true}
                            onSubmit={() => {
                                _closeHelpModal();
                                props.handleOnClose(INFO_CODE.ALL_SET)
                            }}
                            ok={{
                                hidden: (tree?.chain[0] == "all_set" || deviceInfoMessages.info_code == INFO_CODE.ALL_SET) ? false : true,
                                translationKey: ct("rta-trmc.premeeting.joinMeeting")
                            }}
                            disableBackdropClose={true}

                            back={{
                                hidden: !renderBackUI()?.show,
                                translationKey: ct("rta-trmc.premeeting.back"),
                                onClick: () => handleBack(renderBackUI()?.backChain,
                                    renderBackUI()?.init)
                            }}
                            onCancel={() => getCancelHomeBtn().handle()}
                            cancel={{
                                hidden: getCancelHomeBtn().hide,
                                translationKey: getCancelHomeBtn().text
                            }}
                            rtaClassName={'prejoin-popup'}
                            testId={"common-pop-modal-info-code"}
                        >
                            <div className="color-black-pre">
                                {
                                    initLink
                                        ? initMessageView()
                                        : messageView(deviceGuide)

                                }
                                {
                                    getCancelHomeBtn(false, true)
                                }
                            </div>
                        </Dialog>
                    </div >
                </ModalTransition>
            </>
        )
    } else {
        return null;
    }
}

export const makeHostRoomStatus = async () => {
    const { roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX)
    let roomorIpAddressNew = roomorIpAddress
    let resp = await getBoxRoomApi('?visibleRoom=' + CURRENT_ROOM_NAME)

    if (resp.status == 1) {
        roomorIpAddressNew = resp.deviceRoom;
    }

    if (roomorIpAddressNew) {
        if (_ValidateIPaddress(roomorIpAddressNew)) {
            if (roomorIpAddressNew.indexOf("_") != -1) {
                roomorIpAddressNew = roomorIpAddressNew.replace("_", ":")
            }
        }
    }

    dispatch(setRoomorIpAddress(roomorIpAddressNew, "device connect manually"))
    return roomorIpAddressNew
}

export const userHasSubscription = (getCancelAlso = false, pack_id = null) => {
    let curTime = Math.round(new Date().getTime() / 1000);
    const { userPaymentSubscription } = getStore(FEATURE_CUSTOM_PAYMENT)
    let hasSubscription = false;
    if (userPaymentSubscription.pack_id) {
        hasSubscription = true;
        if (userPaymentSubscription.is_canceled == false) {
            if (userPaymentSubscription.end_at < curTime) {
                hasSubscription = false;
            } else {
                hasSubscription = true;
            }
        } else {
            if (userPaymentSubscription.is_canceled) {
                if (getCancelAlso) {
                    if (userPaymentSubscription.end_at > curTime) {
                        hasSubscription = true;
                    }
                }
            } else {
                hasSubscription = false;
            }
        }

        if (hasSubscription) {
            if (userPaymentSubscription.is_ended) {
                hasSubscription = false
            }
        }
    }
    return hasSubscription;
}

export const changeFader = (value, index, item, usersData) => {
    const { roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX);
    const { prejoinScreenDetail } = getStore(FEATURE_CUSTOM_REDUX_V2);
    if (prejoinScreenDetail.isSet) {
        return false;
    }

    if (usersData) {
        try {


            const usersArr = usersData.users;
            let jitsiModerator = false;

            usersArr[index].volumeLevel = value == 1 ? 0
                : value == 2 ? 12
                    : value == 3 ? 25
                        : value == 4 ? 37
                            : value == 5 ? 50
                                : value == 6 ? 63
                                    : value == 7 ? 75
                                        : value == 8 ? 87 : 100;

            let faderLevel = 0;
            if (value && value == 1) {
                faderLevel = 0;
            } else if (value && value == 2) {
                faderLevel = 12;
            } else if (value && value == 3) {
                faderLevel = 25;
            } else if (value && value == 4) {
                faderLevel = 37;
            } else if (value && value == 5) {
                faderLevel = 50;
            } else if (value && value == 6) {
                faderLevel = 63;
            } else if (value && value == 7) {
                faderLevel = 75;
            } else if (value && value == 8) {
                faderLevel = 87;
            } else if (value && value == 9) {
                faderLevel = 100;
            }

            let setIndex = item.index;
            if (setIndex == null || setIndex == undefined) {
                setIndex = index;
            }

            const message = {
                action: {
                    index: setIndex,
                    faderLevel,
                    isMute: item.isMute,
                    isSolo: item.isSolo,
                    uniqueID: usersData.uniqueId,
                    ipAddress: roomorIpAddress,
                    jitsiModerator
                },
                content: 'setting-to-app',
                isBroadcast: true,
                sender: 'mobile'
            };

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            //sendDataToSocket(message);
            sendData(message);
        } catch (e) {

        }
    }
}

export const SocketListnerInitApi = () => {

    let {
        userLoginData,
        showLoader,
        conferenceJoined,
        usersData,
        protocolId,
        uniqueId,
        isConnectedAudioGhost,
        audioGhostId
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX])

    const {
        showPrejoinLoader,
        showDevicePreConnection
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V3])

    const {
        userSubscriptionModel
    } = useSelector((state: IToolWebjamV4) => state[FEATURE_CUSTOM_REDUX_V4])
    let {
        authOrganization,
        prejoinScreenDetail,
        joinRoomWithoutDevice
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V2])

    useEffect(() => {
        socketOn("user_subscription", data => {
            let { windowRef } = getStore(FEATURE_CUSTOM_PAYMENT);
            let { userLoginData, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
            if (userLoginData.user) {
                try {
                    if (data.user_id == userLoginData.user?.id) {
                        if (windowRef.package_id == data.package_id) {
                            if (conferenceJoined || CURRENT_ROOM_NAME.length < 2) {
                                dispatch(showApiLoader())
                                setTimeout(function () {
                                    dispatch(hideApiLoader())
                                }, 2000)
                                dispatch(getMySubscription());
                                // comment below code because it block success message page after payment on stripe
                                // if (windowRef.win) {
                                //     windowRef.win.close();
                                // }
                            }
                        }
                    }
                } catch (e) {
                    console.log("user_subscription error =>", e)
                }
            }
        })

        let localSocketId = localStorage.getItem('socketId');

        // setTimeout(() => {
        //     if (!conferenceJoined) {
        //         socketEmit("get_open_tool", {
        //             location: window.location.origin,
        //             room: CURRENT_ROOM_NAME,
        //             socketId: localSocketId,
        //         });
        //     }
        // }, 2000)

        _getUserLanguage()
        setMusicModeSocialStore()
    }, []);


    const _getUserLanguage = async () => {
        // to set user social language
        let getUserLang = await getUserLanguage();
        if (getUserLang.status && getUserLang.data) {
            i18next.changeLanguage(getUserLang.data);
        }
    }

    const setMusicModeSocialStore = () => {
        const musicModeStoreValue = getQueryString('musicModeStore');
        if (musicModeStoreValue) {
            try {
                let mainData = atob(musicModeStoreValue);
                mainData = JSON.parse(mainData);
                if (mainData.hasOwnProperty("local")) {
                    let localStore = mainData["local"];
                    let firstKey = Object.keys(localStore)[0];
                    localStorage.setItem(firstKey, localStore[firstKey])
                }
                if (mainData.hasOwnProperty("session")) {
                    let sessionStore = mainData["session"];
                    let _firstKey = Object.keys(sessionStore)[0];
                    sessionStorage.setItem(_firstKey, sessionStore[_firstKey])
                }
            } catch (e) {
                console.log("music mode flag error", e)
            }
        }
    }

    let prevUsersData = usePrevious(usersData);
    useEffect(() => {
        let finalUsers = [];
        if (!prevUsersData && usersData?.users?.length > 0) {
            finalUsers = [...usersData.users]
        } else {
            if (prevUsersData?.users?.length != usersData?.users?.length && prevUsersData?.users?.length < usersData?.users?.length) {
                if (!prevUsersData?.users?.length && usersData.users?.length) {
                    finalUsers = [...usersData.users]
                } else {
                    const results = usersData?.users.filter((value) => !prevUsersData?.users.some((value1) => value.index == value1.index));
                    finalUsers = [...results]
                }
            }
        }
        if (finalUsers.length) {
            finalUsers.forEach((item) => {
                changeFader(9, item.index, item, usersData)
            })
        }
        if (usersData != null && prevUsersData == null) {
            if (conferenceJoined) {
                if (getBaseConfig("recheckConnectDevice") == true) {
                    // add ping status if i'm first user if prejoin table's has not exists then save data
                    getDevicePingStatus({
                        device_id: usersData.uniqueId,
                        protocol_id: protocolId,
                        room_name: CURRENT_ROOM_NAME,
                        is_reconnect: true
                    })
                }
                try {
                    if (getBaseConfig("saveDeviceConnectSession") == true) {
                        // Save device is connected by user in session
                        saveDeviceConnectSession({
                            box_id: usersData.uniqueId,
                            roomname: CURRENT_ROOM_NAME,
                            user_id: userLoginData.user.id,
                            organization_id: authOrganization._id
                        }).then(data => {
                            console.log("saveDeviceConnectSession then =>", data)
                        })
                    }
                } catch (e) {
                    console.log("saveDeviceConnectSession error =>", e)
                }

                try {
                    if (isConnectedAudioGhost && audioGhostId) {
                        dispatch(setVolume(audioGhostId, 0));
                    }
                } catch (e) {
                    console.log("Hybrid function error =>", e)
                }
            }
        }
    }, [usersData]);

    let prevLogin = usePrevious(userLoginData);

    useEffect(() => {
        if (prevLogin != userLoginData) {
            let willRun = false;
            if (prevLogin) {
                if (prevLogin.hasOwnProperty("user") && prevLogin?.user != userLoginData.user) {
                    if (userLoginData.user.id) {
                        willRun = true;
                    }
                }
            } else {
                if (userLoginData.user) {
                    willRun = true;
                }
            }

            if (willRun) {
                getPackageList().then(async res => {
                    console.log("Fetching ")
                    if (res.status == 1) {
                        let data = res?.data?.data;
                        let finalData = {};

                        if (data && data.length) {
                            data = await Promise.all(data.map(async main => {
                                main.features = await Promise.all(main.features.map(async feature => {
                                    feature.descriptions = await Promise.all(feature.descriptions.map(async description => {
                                        return await dynamicMessageLocale(description)
                                    }))
                                    feature.title = await dynamicMessageLocale(feature.title)
                                    return feature;
                                }))
                                return main;
                            }))

                            for (let i = 0; i < data.length; i++) {
                                if (data[i].package_type != undefined) {
                                    if (finalData[data[i].package_type] == undefined) {
                                        finalData[data[i].package_type] = []
                                    }
                                    finalData[data[i].package_type].push(data[i])
                                }
                            }
                        }
                        if (Object.keys(finalData).length) {
                            dispatch(setSubscriptionPackage(finalData))
                        } else {
                            dispatch(setSubscriptionPackage({}))
                        }
                    }
                })
            }
        }
    }, [userLoginData])

    let localMusicMode = localStorage.getItem("musicModeUser")

    const handleCloseSubscription = () => {
        dispatch(setUserSubscriptionModal(false))
    }

    return (<>
        {showDevicePreConnection && <DevicePreConnection
            uniqueId={uniqueId}
            protocolId={protocolId}
            prejoinScreenDetail={prejoinScreenDetail}
            usersData={usersData}
            joinRoomWithoutDevice={joinRoomWithoutDevice}
        />}

        {userSubscriptionModel &&
            <UserSubscription
                socialTrigger={true}
                closeSubscription={handleCloseSubscription}
            />
        }

        {getBaseConfig("showPreJoiningInConference") && CURRENT_ROOM_NAME && !localMusicMode &&
            <Zendesk zendeskKey={ZENDESK_KEY} {...setting}
                onLoaded={() => {
                    zE("webWidget:on", "open", function () {
                        dispatch(setZendeskState(true));
                    });
                    zE("webWidget:on", "close", function () {
                        dispatch(setZendeskState(false));
                    });
                    zE('webWidget', 'setLocale', i18next.language);
                }}

            />}
    </>);
}

export const ThemedModal = (props) => {

    const handleClose = () => {
        props.handleClose(true)
    }

    return (
        <>
            <ModalTransition>
                <ModalDialog
                    width="medium"
                    heading={props.title}
                    onClose={() => handleClose()}
                    testId={"user-subscription-modal"}
                    components={{
                        Footer: () => <ModalFooter
                            showKeyline={false}
                            className={"info-message-modal"}
                        >
                            <div className={"w-100 d-flex justify-content-end"}>
                                {!getBaseConfig("showPreJoiningInConference") &&
                                    <Button appearance="subtle" className="cancel-button pull-right" onClick={() => handleClose()} >{ct("Translate.buttonTitle.closeSmall")} </Button>
                                }

                                {
                                    props?.isLink ? <Button appearance="subtle" className="cancel-button pull-right" onClick={() => handleClose()} >{ct("Translate.buttonTitle.closeSmall")} </Button> : ""
                                }
                            </div>
                        </ModalFooter>
                    }}
                >
                    <div className="color-black-pre">
                        <p className="font16">

                            {props?.isLink
                                ? <iframe src={props.message}
                                    height={600}
                                    width={500}
                                    target="_parent"
                                    type="text/html"
                                    frameborder="0"
                                    allowfullscreen
                                ></iframe>
                                : props.message}
                        </p>
                    </div>
                </ModalDialog>
            </ModalTransition >
        </>
    )
}

export const canUserJoinMeeting = (allowJoinButton = false) => {
    let allowJoin = false;

    if (getBaseConfig("showDevicePreJoining") == true) {
        let userSubscription = userHasSubscription(true);
        let {
            userLoginData,
            usersData,
            isWaiting
        } = getStore(FEATURE_CUSTOM_REDUX);

        let {
            userPaymentSubscription
        } = getStore(FEATURE_CUSTOM_PAYMENT)

        let {
            prejoinStepFlag,
            joinRoomWithoutDevice
        } = getStore(FEATURE_CUSTOM_REDUX_V2)

        let {
            prejoinSubscription
        } = getStore(FEATURE_CUSTOM_REDUX_V3)
        if (userLoginData?.user?.id) {
            if (userSubscription) {
                allowJoin = true;
                if (usersData != undefined) {
                    if (!userPaymentSubscription.is_premium) {
                        allowJoin = false
                    }
                }
            } else if (userLoginData?.user?.is_invited && usersData != undefined) {
                allowJoin = false
            }
        }
        if (allowJoin) {
            if (prejoinStepFlag != systemBootMessage.AUDIO) {
                allowJoin = false
            } else if (prejoinStepFlag == systemBootMessage.AUDIO && joinRoomWithoutDevice == true) {
                allowJoin = true
            } else {
                allowJoin = false
            }
        }

        if (!allowJoin) {
            if (usersData != null) {
                if (prejoinStepFlag == systemBootMessage.AUDIO && joinRoomWithoutDevice == true) {
                    if (userSubscription) {
                        if (!userPaymentSubscription.is_premium) {
                            allowJoin = true
                        }
                    }
                }
            }
        }

        if (!allowJoin) {
            if (sessionStorage.getItem("up_time_" + CURRENT_ROOM_NAME)) {
                if (calculateTimeDiff(sessionStorage.getItem("up_time_" + CURRENT_ROOM_NAME), 30)) {
                    allowJoin = true;
                }
            }
        }

        // if(allowJoin){
        //     if(isWaiting){
        //         allowJoin = false;
        //     }
        // }
    } else {
        allowJoin = true
    }
    if (allowJoinButton) {
        let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
        let { isPremeetingSubscriptionUI } = getStore(FEATURE_CUSTOM_REDUX_V3)
        let userSubscription = userHasSubscription(true);
        if (!allowJoin && getBaseConfig("noDevicePreJoiningScreen") && userSubscription && !conferenceJoined && isPremeetingSubscriptionUI) {
            allowJoin = true
        }
    }
    // 22 jun
    if (!getBaseConfig("showDevicePreJoining")) {
        allowJoin = true
    }
    return allowJoin
}

export const MultipleDeviceList = (props) => {

    const {
        prejoinAvailableDevice
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V3]);

    const { isZendeskOpen } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V2])
    const [devices, setDevices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // let activeDevice = props.deviceList || []
        // if (prejoinAvailableDevice && prejoinAvailableDevice.length) {
        //     activeDevice = activeDevice.concat(prejoinAvailableDevice)
        // }
        // activeDevice = [...new Set(activeDevice)];
        // setDevices(activeDevice)
        updateDeviceList()
        if (window.innerWidth < 768) {
            if (document.getElementById("launcher")) {
                let { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
                if (getBaseConfig("showPreJoiningInConference") && showDevicePreConnection) {
                    document.getElementById("launcher").style.display = '';
                } else {
                    document.getElementById("launcher").style.display = 'none';
                }
            }
        }

        return () => {
            if (window.innerWidth < 768) {
                if (document.getElementById("launcher")) {
                    let { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
                    if (getBaseConfig("showPreJoiningInConference") && showDevicePreConnection) {
                        document.getElementById("launcher").style.display = '';
                    } else {
                        document.getElementById("launcher").style.display = 'block';
                    }
                }
            }
        }
    }, [])

    const handleClose = (data) => {
        props.handleMultipleDevice(data)
    }

    const updateDeviceList = () => {
        let activeDevice = props.deviceList || []
        if (prejoinAvailableDevice && prejoinAvailableDevice.length) {
            activeDevice = activeDevice.concat(prejoinAvailableDevice)
        }
        activeDevice = [...new Set(activeDevice)];
        setDevices(activeDevice)
    }

    let prevAvailDevice = usePrevious(prejoinAvailableDevice);
    useEffect(() => {
        if (prevAvailDevice) {
            if (!_.isEqual(prevAvailDevice, prejoinAvailableDevice)) {
                updateDeviceList()
            }
        }
    }, [prejoinAvailableDevice])

    let prevDeviceList = usePrevious(props.deviceList);
    useEffect(() => {
        if (prevDeviceList) {
            if (!_.isEqual(prevDeviceList, props.deviceList)) {
                updateDeviceList()
            }
        }
    }, [props.deviceList])

    const handleRefresh = () => {
        updateDeviceList()
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false)
        }, 2000)
    }

    if (isZendeskOpen) {
        return null;
    }
    return (
        <>

            <ModalTransition>
                <div className="webjam-popup">
                    <Dialog
                        titleKey={ct("rta-trmc.rtaDeviceListDialog.selectRealTime")}
                        onCancel={() => handleClose()}
                        cancel={{
                            translationKey: ct("rta-trmc.premeeting.skipAndContinue")
                        }}
                        ok={{
                            hidden: true
                        }}
                        rtaClassName={'prejoin-device-list'}
                        hideCloseButton={true}
                        testId={"common-pop-modal-info-code"}
                    // shouldCloseOnOverlayClick={false}
                    // shouldCloseOnEscapePress={false}
                    // components={{
                    //     Footer: () => <ModalFooter
                    //         showKeyline={false}
                    //         className={"info-message-modal w-100 d-flex justify-content-end"}
                    //     >
                    //         <Button appearance="subtle" className="cancel-button pull-right" onClick={() => handleClose()} >Skip and Continue</Button>
                    //     </ModalFooter>
                    // }}
                    >
                        {isLoading &&
                            <>
                                {getBaseConfig("showPushSpinnerLoader") ?
                                    <div className="loader-text-container C">
                                        <div className='loader-wrapper'>
                                            <PushSpinner
                                                size={30}
                                                color="white"
                                                loading={true}
                                                className={"loader-text-main"}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <Loader
                                        loaded={false}
                                        options={{
                                            color: '#fff'
                                        }}
                                        className={"loader-text-main"}
                                    > </Loader>
                                }
                            </>
                        }
                        <div className="parent-dvc">
                            <div className="prejoin-refresh-list"
                                onClick={() => handleRefresh()}
                            >
                                <img className="refresh" src={refresh} />
                            </div>
                            <div className="container-fluid">
                                <div className="setting-advance-main mt-3">
                                    <span className="d-block px-4 text-center mh-500">
                                        {
                                            devices.map((item, idx) => {
                                                return (
                                                    <div key={idx}>
                                                        <div className="box-btn-wrap">
                                                            <input style={{ cursor: 'pointer' }} key={idx} type="text" value={item} onClick={() => handleClose(item)} className="form-control" readOnly />
                                                            <button onClick={() => handleClose(item)} className="w-50">{ct("rta-trmc.premeeting.select")}</button>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                </div >
            </ModalTransition >
        </>
    )
}

export const isChinaRegion = async () => {
    if (getBaseConfig("getRegionInfo")) {
        let regionData = await getUserLocation();
        if (regionData) {
            regionData = regionData.basicInfo;
            if (regionData?.user_country.toLowerCase() == 'china') {
                dispatch(setIsChinaRegion(true));
                return true;
            }
            dispatch(setIsChinaRegion(false));
            return false;
        }
    }
    dispatch(setIsChinaRegion(false));
    return false;
}

export const sortLanguageAlphabetically = (a, b) => {
    let x = a.label.toLowerCase();
    let y = b.label.toLowerCase();
    if (x < y) {
        return -1;
    }
    if (x > y) {
        return 1;
    }
    return 0;
};